import { theme } from '@zappyrent/hundop';
import {
  CheckCircle2Icon,
  AlertCircleIcon,
  InfoIcon,
  XCircleIcon,
  XIcon,
} from 'lucide-react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { useToastContext } from '../../contexts/ToastProvider';
import { StyledToast, StyledToastWrapper } from './Toast.styles';
import { IToastProps } from './Toast.types';

const toastTypes = {
  success: {
    icon: <CheckCircle2Icon color={theme.colors.cross.greenMint} />,
    color: theme.colors.cross.greenMint,
  },
  warning: {
    icon: <AlertCircleIcon color={theme.colors.cross.arancin} />,
    color: theme.colors.cross.arancin,
  },
  info: {
    icon: <InfoIcon color={theme.colors.tenant.main} />,
    color: theme.colors.tenant.main,
  },
  error: {
    icon: <XCircleIcon color={theme.colors.cross.red} />,
    color: theme.colors.cross.red,
  },
};

const Toast = ({ id, message, type }: IToastProps): JSX.Element | null => {
  const { icon, color } = toastTypes[type];
  const toast = useToastContext();

  const handleDismiss = () => {
    toast.remove(id);
  };

  useEffect(() => {
    const id = setTimeout(() => {
      handleDismiss();
    }, 5000);

    return () => {
      clearTimeout(id);
    };
  }, []);

  return createPortal(
    <StyledToastWrapper container>
      <StyledToast lg={2} toastTypeColor={color}>
        {icon}
        {message}
        <XIcon size={15} onClick={handleDismiss} cursor="pointer" />
      </StyledToast>
    </StyledToastWrapper>,
    document.getElementById('toast')!,
  );
};

export default Toast;
